import type { OrganizationShowQueryType } from "@/types/graphql/admin.generated";
import { OrganizationDetails } from "../OrganizationDetails";

export const OrganizationShowComponent: React.ComponentType<{
  editData?: unknown;
  organization?: OrganizationShowQueryType["organization"];
}> = ({ organization }) => {
  if (!organization) return <div>Загрузка...</div>;

  return <OrganizationDetails organization={organization} />;
};
